// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12MZ1","rootMobile":"styles_rootMobile__783fc"};